import { views } from '@/v-shop/autoloader'

export default () => [
	{
		path: '/catalogo-online',
		name: 'pdf-viewer',
		component: views.PdfViewer,
	},
]
